<template>
  <div class="modal fade" id="recommendModal" style="overflow: auto!important;" tabindex="-1" role="dialog"
    aria-labelledby="recommendModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-v2 modal-lg" role="document">
      <div class="modal-content modal-content-v2">
        <div class="modal-header modal-header-v2">
          <div class="header-content-v2">
            <i class="fa fa-border-all header-icon-v2"></i>
            <h5 class="modal-title-v2" id="recommendModalLabel">Супутні кромки</h5>
          </div>
          <button type="button" class="close close-v2" data-dismiss="modal" aria-label="Close">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body-v2">
          <div class="material-info-v2">
            <div class="material-content-v2">
              <i class="fa fa-cube material-icon-v2"></i>
              <h6 v-if="material" class="material-title-v2">{{ material.full_name || '' }}</h6>
            </div>
            <div class="checkbox-all-v2">
              <input type="checkbox" id="check-all" @change="reverseCheckboxes" :checked="checked"
                class="checkbox-input-v2" value="true">
              <label style="margin: 0;" for="check-all" class="checkbox-label-v3"></label>
            </div>
          </div>
          <div v-if="loading" class="loading-container-v2">
            <div class="preloader-v2" ref="preloader">
              <div class="spinner-v2"></div>
              <p class="loading-text-v2">Завантаження...</p>
            </div>
          </div>
          <div v-if="received.length && !this.loading" class="recommends-list-v2">
            <div v-for="(item, index) in received" :key="index" class="recommend-item-v2">
              <div class="recommend-image-v2">
                <img :src="appconfig.Point + `/` + item.image" :alt="item.full_name" loading="lazy" />
              </div>

              <div class="recommend-content-v2">
                <div class="recommend-header-v2">
                  <div v-if="item.on_order" class="order-badge-v2">Під замовлення</div>
                  <h4 class="recommend-title-v2">{{ item.full_name }}</h4>
                  <div class="recommend-meta-v2">
                    <span class="recommend-code-v2">Код: {{ item.code }}</span>
                    <span class="recommend-status-v2" :class="it(item).quantity == 0 ? 'status-order' : 'status-stock'">
                      <i :class="it(item).quantity == 0 ? 'fa fa-truck' : 'fa fa-check-circle'"></i>
                      {{ it(item).quantity == 0 ? 'Термін постачання до: ' + item.term_order + ' дн.' : 'В наявності' }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="recommend-price-v2">
                <div v-if="it(item).price > 0" class="price-info-v2">
                  <span class="price-value-v2">{{ it(item).pr.toFixed(2) }}</span>
                  <span class="price-currency-v2">{{ it(item).cy_name }}</span>
                  <span class="price-unit-v2">{{ it(item).sale_unit_name }}</span>
                </div>
              </div>

              <div class="recommend-checkbox-v2">
                <input v-if="canSelect(it(item))" type="checkbox" :data-ref="item.ref" :id="'_' + item.ref"
                  v-model="item.checked" class="checkbox-input-v2" value="true">
                <label :for="'_' + item.ref" class="checkbox-label-v3"></label>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer-v2">
          <button class="btn-v2 btn-primary-v2" @click="takeItems()">
            <i class="fa fa-check"></i>
            Обрати
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import axios from "axios";

export default {
  name: "recommendRender",
  data() {
    return {
      appconfig: appconfig,
      edges: [],
      material: false,
      received: [],
      loading: false,
      checked: false,
    }
  },
  computed: {
    allowNoPrice() {
      return this.$store.state.auth.settings.allow_no_price || false;
    }
  },
  methods: {
    takeItems() {
      this.received.forEach((edge) => {
        if (!edge.checked) return;
        let elem = this.$store.state.data.edges.find(el => el.ref === edge.ref) || null;
        if (elem) return;
        this.$store.commit('data/ADD_EDGES', this.it(edge));

        $('#recommendModal').modal('hide');
      });

    },
    reverseCheckboxes() {
      this.checked = !this.checked;
      this.received.map(el => {
        const item = this.it(el);
        return el.checked = this.checked && this.canSelect(item);
      });
    },
    receive() {
      let request = '';
      this.edges.forEach((el, i) => {
        request += 'i' + el.code;
      });
      this.loading = true;
      axios.post(appconfig.Point + 'api/constructor/v1/products', {
        by: 'code',
        search: request,
        take: 20,
        token: (this.$store.state.auth.user.token || null)
      })
        .then(response => {
          this.received = response.data;
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
        })
    },
    it(item) {
      return this.received.find(el => el.ref === item.ref) || {};
    },
    canSelect(item) {
      // Если allow_no_price включен, показываем всегда
      if (this.allowNoPrice) {
        return true;
      }
      // Иначе показываем только если есть цена
      return item.price > 0;
    },
  },
  mounted() {
    this.$root.$on('edges_change', data => {
      this.edges = data.edges;
      this.material = data.material;
      this.receive();
      this.checked = false;
      this.edges.map(el => {
        el.checked = false;
      });
    });
    $('#recommendModal').on('hidden.bs.modal', () => {
      this.$root.$emit('modal.change')
    });
  }
}
</script>

<style scoped>
/* Component-specific overrides for recommendRender */
/* Uses 4-column grid with checkbox at the end */
.recommend-item-v2 {
  grid-template-columns: 80px 1fr 150px 40px;
}

.recommends-list-v2 {
  background: white;
  border-radius: 8px;
  overflow: hidden;
}
</style>